<template>
  <div>
    <div class="station-heat-type">
      <Select v-model="queryModel.heatType" style="width:100px" size="small" @on-change="handleChangeHeatType">
        <Option value="0">投放量</Option>
        <Option value="1">去化率</Option>
        <Option value="2">预售率</Option>
        <Option value="3">品牌指数</Option>
      </Select>
    </div>

    <div class="center-block-date">
      <DatePicker v-model="queryModel.startDate" type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
      <span class="m-l-5 m-r-5">至</span>
      <DatePicker v-model="queryModel.endDate"  type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
    </div>

    <div id="heatMapHtml"></div>
  </div>
</template>

<script>
import { GetCurrentMonth, lastMonthDate, ParseDate } from '@/utils/dateFormat'
import { getStorage } from '@/utils/storage'

import { getCompanyDateConfig } from '@/api/dw/time'
import { getCenterStationCoordinate } from '@/api/product/station'
import { countBrandNumberGbStationName, listResourceRateGbStationName } from '@/api/dw/station'

export default {
  data () {
    return {
      mapUrl: '',
      amapObject: null, // 地图对象
      heatmapObject: null,
      publisherId: this.$store.getters.token.userInfo.publisherId,
      loginCompanyId: this.$store.getters.token.userInfo.companyId,
      publisherCityCode: this.$store.getters.token.userInfo.publishers[0].cityCode,
      mapCityCenter: [
        { cityCode: '350200', cityName: '厦门市', center: [118.103886046, 24.4892306125] },
        { cityCode: '370200', cityName: '青岛市', center: [120.383414, 36.075069] },
        { cityCode: '110100', cityName: '北京市', center: [116.395645038, 39.9299857781] },
        { cityCode: '330200', cityName: '宁波市', center: [121.579005973, 29.8852589659] },
        { cityCode: '510100', cityName: '成都市', center: [104.076673, 30.550755] },
        { cityCode: '530100', cityName: '昆明市', center: [102.722601, 25.014105] },
        { cityCode: '440600', cityName: '佛山市', center: [113.134025635, 23.0350948405] },
        { cityCode: '350100', cityName: '福州市', center: [119.330221107, 26.0471254966] }
      ],

      dateOptions: {}, // 禁用时间项

      queryModel: {
        heatType: '0',
        endDate: '',
        startDate: ''
      }
    }
  },
  beforeDestroy () {
    this.amapObject && this.amapObject.destroy()
  },
  mounted () {
    if (this.themeIsDark) {
      // 路面媒体，如公交广告的mediaType为 2。 其余按照地铁来处理
      this.mapUrl = (this.$store.getters.token.publisherSetting.mediaType === 2)
        ? 'amap://styles/1f4dd7eedc2e98a369065bc005756706' : 'amap://styles/22479512d3a2c18a06bc6ec613e012c7'
    }

    // 设置地图宽高
    this.resizeMap()
    const that = this
    window.addEventListener('resize', function () {
      that.resizeMap()
    })

    this.queryModel.startDate = this.searchSchedule.startDate
    this.queryModel.endDate = this.searchSchedule.endDate
    this.initPageData()
  },
  methods: {
    initPageData () {
      const postData = { companyId: this.loginCompanyId }
      getCompanyDateConfig(postData).then(res => {
        this.dateOptions = {
          disabledDate (date) {
            return (date && date.valueOf() < new Date(res.startDate).valueOf() - 86400000) ||
            (date && date.valueOf() > new Date(res.endDate).valueOf())
          }
        }
      })

      // 延迟加载，防止出现AMap not defined
      setTimeout(() => {
        this.initMapData()
      }, 1000)
    },
    initMapData () {
      // 获取地图中心点
      let center = this.mapCityCenter.find(x => x.cityCode === this.publisherCityCode).center

      if (this.assetId !== '0') {
        getCenterStationCoordinate({ assetId: this.assetId }).then(res => {
          center = [res.x, res.y]
          this.loadMap(center)
          this.createHeatMap()
        })
      } else {
        this.loadMap(center)
        this.createHeatMap()
      }
    },
    loadMap (center) {
      this.amapObject = new AMap.Map('heatMapHtml', {
        center: center,
        zoom: 12,
        mapStyle: this.mapUrl,
        zooms: [10, 16]
      })
    },
    resizeMap () {
      if (document.getElementById('heatMapHtml')) { // 防止切换界面，或者内容丢失后出错
        const centerBlock = document.getElementById('heatMapHtml').parentNode.parentNode.parentNode
        document.getElementById('heatMapHtml').style.width = centerBlock.clientWidth + 'px'
        document.getElementById('heatMapHtml').style.height = centerBlock.clientHeight + 'px'
      }
    },
    createHeatMap () {
      const __this = this
      this.amapObject.plugin(['AMap.HeatMap'], function () {
        // 初始化heatmap对象
        __this.heatmapObject = new AMap.HeatMap(__this.amapObject, {
          radius: 40 // 给定半径
          // gradient: {
          //   0.2: '#00FFFF',
          //   0.4: '#207cca',
          //   0.6: '#31ff00',
          //   0.8: '#f8ff00'
          //   // 0.95: '#ff0500'
          // }
        })
        __this.handleChangeHeatType()
      })
    },
    loadBrandNumber (searchModel) {
      countBrandNumberGbStationName(searchModel).then(res => {
        let maxCount = 0
        const heatData = []
        res.forEach(item => {
          if (item.lng !== '') {
            if (maxCount < item.number) {
              maxCount = item.number
            }
            heatData.push({
              lng: parseFloat(item.lng),
              lat: parseFloat(item.lat),
              count: item.number
            })
          }
        })

        if (maxCount > 0) { // 防止无数据导致出现蓝色圆圈
          this.setMapHeatData(heatData, maxCount)
        }
      })
    },
    setMapHeatData (heatData, maxCount) {
      if (this.heatmapObject) {
        this.heatmapObject.setDataSet({
          data: heatData,
          max: maxCount
        })
      } else {
        const _self = this
        setTimeout(() => {
          _self.setMapHeatData(heatData, maxCount)
        }, 1000)
      }
    },
    loadResourceRate (searchModel) {
      listResourceRateGbStationName(searchModel).then(res => {
        let maxCount = 0
        const heatData = []
        res.forEach(item => {
          if (item.lng !== '') {
            if (this.queryModel.heatType === '0') {
              if (maxCount < item.number) {
                maxCount = item.number
              }
              heatData.push({
                lng: parseFloat(item.lng),
                lat: parseFloat(item.lat),
                count: item.number
              })
            } else {
              if (maxCount < item.rate) {
                maxCount = item.rate
              }
              heatData.push({
                lng: parseFloat(item.lng),
                lat: parseFloat(item.lat),
                count: item.rate
              })
            }
          }
        })

        this.setMapHeatData(maxCount > 0 ? heatData : [], maxCount)
      })
    },
    handleChangeHeatType () {
      const searchModel = {
        startDate: this.searchSchedule.startDate,
        endDate: this.searchSchedule.endDate,
        publisherId: this.publisherId,
        assetId: this.assetId,
        companyId: this.companyId,
        queryType: this.gbType,
        queryValue: this.gbId
      }

      if (this.queryModel.heatType === '2') { // 预售率
        searchModel.startDate = GetCurrentMonth().startDate
        const dateObj = new Date()
        searchModel.endDate = lastMonthDate(dateObj.getFullYear(), dateObj.getMonth() + 5)
        this.loadResourceRate(searchModel)
      } else if (this.queryModel.heatType === '3') { // 品牌指数
        this.loadBrandNumber(searchModel)
      } else {
        this.loadResourceRate(searchModel)
      }
    },
    handleChangeDate () {
      const curEndDate = new Date(this.queryModel.endDate)
      const formatEndDate = lastMonthDate(curEndDate.getFullYear(), curEndDate.getMonth() + 1)

      const schedule = {
        startDate: ParseDate(this.queryModel.startDate),
        endDate: ParseDate(formatEndDate)
      }

      // 清空左侧的选项数据
      this.$store.commit('set_situation_companyId', (this.loginCompanyId === this.publisherId) ? '0' : this.loginCompanyId)
      this.$store.commit('set_situation_assetId', '0')
      this.$store.commit('set_situation_productIds', [])

      this.$store.commit('set_situation_searchSchedule', schedule)
      // 重新加载当前地图数据
      this.handleChangeHeatType()
    }
  },
  computed: {
    searchSchedule () {
      return this.$store.state.situationWeb.searchSchedule
    },
    companyId () {
      return this.$store.state.situationWeb.companyId
    },
    assetId () {
      return this.$store.state.situationWeb.assetId
    },
    gbType () {
      return this.$store.state.situationWeb.gbType
    },
    gbId () {
      return this.$store.state.situationWeb.gbId
    },
    beignUpdateMap () {
      return this.$store.state.situationWeb.beignUpdateMap
    },
    themeIsDark () {
      // 获取并设置当前页面的主题
      const theme = getStorage('oohforce-workbench-theme') || 'dark'
      return theme === 'dark'
    }
  },
  watch: {
    beignUpdateMap () {
      this.handleChangeHeatType()
    }
  }

}
</script>

<style>
.station-heat-type{
  position: absolute;
  top: 45px;
  left: 15px;
  z-index: 9999;
}
</style>
